import React, { useState, useMemo, useEffect } from "react";
import useAdminStore from "../store/adminStore";
import useDialogStore from "../store/dialogStore";
import { sendRegistrationStatusEmail } from "../services/emailService";
import "../styles/admin-dashboard.css";

// High-fidelity SVG Icon Components
const IconUsers = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ display: "inline-block", verticalAlign: "middle" }}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const IconCheckCircle = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ display: "inline-block", verticalAlign: "middle" }}>
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

const IconClock = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ display: "inline-block", verticalAlign: "middle" }}>
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const IconAlertTriangle = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ display: "inline-block", verticalAlign: "middle" }}>
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

const IconTrendingUp = ({ size = 14, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ display: "inline-block", verticalAlign: "middle" }}>
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
    <polyline points="17 6 23 6 23 12" />
  </svg>
);

const IconHome = ({ size = 14, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ display: "inline-block", verticalAlign: "middle" }}>
    <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

const IconDollar = ({ size = 14, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ display: "inline-block", verticalAlign: "middle" }}>
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);

const IconBuilding = ({ size = 14, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ display: "inline-block", verticalAlign: "middle" }}>
    <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
    <line x1="9" y1="22" x2="9" y2="16" />
    <line x1="9" y1="16" x2="15" y2="16" />
    <line x1="15" y1="16" x2="15" y2="22" />
    <line x1="8" y1="6" x2="8.01" y2="6" />
    <line x1="16" y1="6" x2="16.01" y2="6" />
    <line x1="8" y1="10" x2="8.01" y2="10" />
    <line x1="16" y1="10" x2="16.01" y2="10" />
  </svg>
);

const IconSearch = ({ size = 18, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ display: "inline-block", verticalAlign: "middle" }}>
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const IconShieldCheck = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ display: "inline-block", verticalAlign: "middle" }}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <polyline points="9 11 11 13 15 9" />
  </svg>
);

const IconMapPin = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ display: "inline-block", verticalAlign: "middle" }}>
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const IconActivity = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ display: "inline-block", verticalAlign: "middle" }}>
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
  </svg>
);

const IconTerminal = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ display: "inline-block", verticalAlign: "middle" }}>
    <polyline points="4 17 10 11 4 5" />
    <line x1="12" y1="19" x2="20" y2="19" />
  </svg>
);

const IconFileText = ({ size = 18, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ display: "inline-block", verticalAlign: "middle" }}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

const IconFolderOpen = ({ size = 22, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ display: "inline-block", verticalAlign: "middle" }}>
    <path d="m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2" />
  </svg>
);

const IconCrossCircle = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ display: "inline-block", verticalAlign: "middle" }}>
    <circle cx="12" cy="12" r="10" />
    <line x1="15" y1="9" x2="9" y2="15" />
    <line x1="9" y1="9" x2="15" y2="15" />
  </svg>
);

const IconTrash = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} style={{ display: "inline-block", verticalAlign: "middle" }}>
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <line x1="10" y1="11" x2="10" y2="17" />
    <line x1="14" y1="11" x2="14" y2="17" />
  </svg>
);

class TabErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("TabErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, color: "#ef4444", background: "#fef2f2", border: "1.5px solid #fca5a5", borderRadius: 12, display: "flex", flexDirection: "column", gap: 12 }}>
          <h4 style={{ margin: 0, fontWeight: 700, fontSize: 16 }}>⚠️ Rendering Error inside "{this.props.tab}" tab</h4>
          <p style={{ margin: 0, fontSize: 13, fontFamily: "monospace", background: "rgba(0,0,0,0.04)", padding: 12, borderRadius: 8, border: "1px solid rgba(0,0,0,0.08)", overflowX: "auto" }}>
            {this.state.error?.toString()}
          </p>
          <button 
            style={{ width: "fit-content", padding: "8px 16px", background: "#ef4444", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 700, fontSize: 13, transition: "background 0.2s" }}
            onClick={() => this.setState({ hasError: false, error: null })}
          >
            Retry Tab Render
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

function AdminDashboardPage() {
  const {
    users,
    deals,
    logs,
    updateUserStatus,
    updateUserRole,
    validateDeal,
    deleteDeal,
    resolveLog,
    simulateError,
    resetAdminData,
    fetchAdminData,
    deleteUser,
  } = useAdminStore();

  const confirm = useDialogStore(state => state.confirm);
  const customAlert = useDialogStore(state => state.alert);

  const [activeTab, setActiveTab] = useState("overview");

  // Fetch from database on load and poll every 10 seconds for live updates
  useEffect(() => {
    fetchAdminData();
    const interval = setInterval(() => {
      fetchAdminData();
    }, 10000);
    return () => clearInterval(interval);
  }, [fetchAdminData]);

  // Filter States
  const [userQuery, setUserQuery] = useState("");
  const [dealQuery, setDealQuery] = useState("");
  const [logFilter, setLogFilter] = useState("All"); // All | Unresolved | Resolved
  const [userStatusFilter, setUserStatusFilter] = useState("All"); // All | Pending | Active | Rejected | Suspended
  const [userTypeFilter, setUserTypeFilter] = useState("All"); // All | Individual | Organization
  const [userSortOption, setUserSortOption] = useState("name_asc"); // name_asc | name_desc | deals_asc | deals_desc | date_asc | date_desc

  // User Profile Drawer State
  const [selectedUserProfile, setSelectedUserProfile] = useState(null);

  // Deal Details Modal State
  const [selectedDealDetails, setSelectedDealDetails] = useState(null);

  // Rejection & Email Preview Modal States
  const [selectedUserForRejection, setSelectedUserForRejection] = useState(null);
  const [selectedRejectionReason, setSelectedRejectionReason] = useState("Incomplete or invalid profile information.");
  const [emailNotification, setEmailNotification] = useState(null);

  // Helper parsers for stage progress
  const getStageNumber = (stageStr) => {
    const match = stageStr?.match(/Module\s+(\d+)/i);
    if (match) return parseInt(match[1], 10);
    if (stageStr === 'Lead Generation') return 1;
    if (stageStr === 'Underwriting') return 4;
    if (stageStr === 'LOI Sent') return 10;
    if (stageStr === 'Under Contract') return 11;
    if (stageStr === 'Due Diligence') return 13;
    if (stageStr === 'Financing & Closing') return 14;
    if (stageStr === 'Asset Plan') return 15;
    if (stageStr === 'Exit Strategy') return 16;
    return 1;
  };

  const getStageName = (num) => {
    const names = {
      1: "Deal Lead Generation",
      2: "Market Intelligence",
      3: "Deal Intake",
      4: "Underwriting Engine",
      5: "Deal Score & Verdict",
      6: "Lender Match Engine",
      7: "Loan Package Generator",
      8: "Outreach & Communication",
      9: "Actions & Follow-up",
      10: "LOI Generator",
      11: "PSA Assistant",
      12: "Escrow & Title Workflow",
      13: "Due Diligence & Title",
      14: "Financing, Closing & Recording",
      15: "Asset Plan & Hold",
      16: "Exit Strategy"
    };
    return names[num] || `Module ${num}`;
  };

  const REJECTION_REASONS = [
    "Incomplete or invalid profile information.",
    "Unverifiable company or website details.",
    "Duplicate account registration.",
    "Invalid or temporary email address domain.",
    "Outside of our current target investment profile."
  ];

  const handleApproveUser = async (user, isReactivation = false) => {
    const confirmMessage = isReactivation
      ? `Are you sure you want to reactivate the suspended profile for ${user.name}?`
      : `Are you sure you want to approve the registration request for ${user.name}?`;
    
    confirm({
      title: isReactivation ? 'Reactivate Profile' : 'Approve User',
      message: confirmMessage,
      type: 'info',
      confirmText: isReactivation ? 'Reactivate' : 'Approve',
      onConfirm: async () => {
        await updateUserStatus(user.id, "Active");
        // Send real email via EmailJS (same service as OTP)
        sendRegistrationStatusEmail({
          toEmail: user.email,
          toName: user.name,
          decision: 'Approved',
          reason: isReactivation
            ? 'Your account access has been reinstated by our administrators. You can now log in and use the platform again.'
            : undefined,
        });
        const emailData = {
          to: user.email,
          subject: isReactivation ? "Your AcquireOS Account Has Been Reinstated" : "Your AcquireOS Account Has Been Approved!",
          body: isReactivation
            ? `Hello ${user.name},\n\nGood news! Your account access has been reinstated by our administrators. You can now log in and use the platform again.\n\nBest regards,\nThe AcquireOS Team`
            : `Hello ${user.name},\n\nCongratulations! Your registration request for AcquireOS has been reviewed and approved by our administrators.\n\nYou can now log in to your account and begin using the platform.\n\nBest regards,\nThe AcquireOS Team`
        };
        setEmailNotification(emailData);
      }
    });
  };

  const handleRejectUserClick = (user) => {
    setSelectedUserForRejection(user);
    setSelectedRejectionReason("Incomplete or invalid profile information.");
  };

  const handleConfirmRejection = async () => {
    if (!selectedUserForRejection) return;
    
    const confirmMessage = "Warning: Once rejected, this user cannot be reactivated from the admin side. The user will have to re-register. Are you sure you want to reject this user registration?";
    
    confirm({
      title: 'Reject Registration',
      message: confirmMessage,
      type: 'danger',
      confirmText: 'Reject User',
      onConfirm: async () => {
        await updateUserStatus(selectedUserForRejection.id, "Rejected");
        // Send real email via EmailJS (same service as OTP)
        sendRegistrationStatusEmail({
          toEmail: selectedUserForRejection.email,
          toName: selectedUserForRejection.name,
          decision: 'Rejected',
          reason: selectedRejectionReason,
        });
        const emailData = {
          to: selectedUserForRejection.email,
          subject: "Update on Your AcquireOS Registration Request",
          body: `Hello ${selectedUserForRejection.name},\n\nThank you for your interest in AcquireOS.\n\nAfter reviewing your registration, we are unable to approve your account at this time.\n\nReason: ${selectedRejectionReason}\n\nIf you believe this is an error, please contact our support team.\n\nBest regards,\nThe AcquireOS Team`
        };
        setEmailNotification(emailData);
        setSelectedUserForRejection(null);
      }
    });
  };

  const handleSuspendUser = async (user) => {
    const confirmMessage = `Are you sure you want to suspend the active profile for ${user.name}? This will restrict their access to the platform.`;
    
    confirm({
      title: 'Suspend Profile',
      message: confirmMessage,
      type: 'warning',
      confirmText: 'Suspend',
      onConfirm: async () => {
        await updateUserStatus(user.id, "Suspended");
        sendRegistrationStatusEmail({
          toEmail: user.email,
          toName: user.name,
          decision: 'Suspended',
          reason: 'Administrator decision to suspend active profile.',
        });
        const emailData = {
          to: user.email,
          subject: "Your AcquireOS Account Access Has Been Suspended",
          body: `Hello ${user.name},\n\nWe would like to inform you that your AcquireOS active profile has been suspended.\n\nReason: Administrator decision.\n\nIf you have any questions, reply to this email or contact our support team.\n\nBest regards,\nThe AcquireOS Team`
        };
        setEmailNotification(emailData);
      }
    });
  };

  const handleDeleteUser = async (user) => {
    const confirmMessage = `Are you sure you want to delete the user entry for ${user.name} permanently? This action is irreversible.`;
    
    confirm({
      title: 'Delete User Entry',
      message: confirmMessage,
      type: 'danger',
      confirmText: 'Delete Permanently',
      onConfirm: async () => {
        await deleteUser(user.id);
      }
    });
  };

  // Simulation Form State
  const [simUser, setSimUser] = useState(users[0]?.email || "");
  const [simComponent, setSimComponent] = useState("Module 4 Underwriting");
  const [simSeverity, setSimSeverity] = useState("High");
  const [simMessage, setSimMessage] = useState("");
  const [simSuccessMsg, setSimSuccessMsg] = useState("");

  // Memoized KPI metrics
  const stats = useMemo(() => {
    const managedUsers = users.filter(u => u.role !== "admin");
    const totalUsers = managedUsers.length;
    const activeUsers = managedUsers.filter(u => u.status === "Active").length;
    const pendingApprovals = managedUsers.filter(u => u.status === "Pending").length;
    const unresolvedErrors = logs.filter((l) => l.status === "Unresolved").length;

    return {
      totalUsers,
      activeUsers,
      pendingApprovals,
      unresolvedErrors,
    };
  }, [users, logs]);

  // Format currency helper
  const formatCurrency = (val) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    }).format(val);
  };

  // Filter & Sort Users
  const filteredUsers = useMemo(() => {
    // Exclude administrators from directory management
    let result = users.filter(u => u.role !== "admin");

    if (userStatusFilter !== "All") {
      result = result.filter((u) => u.status === userStatusFilter);
    }

    if (userTypeFilter !== "All") {
      result = result.filter((u) => (u.userType || "individual").toLowerCase() === userTypeFilter.toLowerCase());
    }

    if (userQuery) {
      const q = userQuery.toLowerCase();
      result = result.filter(
        (u) =>
          u.name.toLowerCase().includes(q) ||
          u.email.toLowerCase().includes(q) ||
          (u.company || "").toLowerCase().includes(q) ||
          (u.orgName || "").toLowerCase().includes(q) ||
          (u.indStrategy || "").toLowerCase().includes(q)
      );
    }

    // Sort result
    result.sort((a, b) => {
      if (userSortOption === "name_asc") {
        return a.name.localeCompare(b.name);
      } else if (userSortOption === "name_desc") {
        return b.name.localeCompare(a.name);
      } else if (userSortOption === "deals_asc") {
        const countA = deals.filter((d) => d.userEmail === a.email).length;
        const countB = deals.filter((d) => d.userEmail === b.email).length;
        return countA - countB;
      } else if (userSortOption === "deals_desc") {
        const countA = deals.filter((d) => d.userEmail === a.email).length;
        const countB = deals.filter((d) => d.userEmail === b.email).length;
        return countB - countA;
      } else if (userSortOption === "date_asc") {
        const dateA = a.registeredAt ? new Date(a.registeredAt) : new Date(0);
        const dateB = b.registeredAt ? new Date(b.registeredAt) : new Date(0);
        return dateA - dateB;
      } else if (userSortOption === "date_desc") {
        const dateA = a.registeredAt ? new Date(a.registeredAt) : new Date(0);
        const dateB = b.registeredAt ? new Date(b.registeredAt) : new Date(0);
        return dateB - dateA;
      }
      return 0;
    });

    return result;
  }, [users, userStatusFilter, userTypeFilter, userQuery, userSortOption, deals]);

  // Filter Deals
  const filteredDeals = useMemo(() => {
    if (!dealQuery) return deals;
    const q = dealQuery.toLowerCase();
    return deals.filter(
      (d) =>
        d.name.toLowerCase().includes(q) ||
        d.userEmail.toLowerCase().includes(q)
    );
  }, [deals, dealQuery]);

  // Filter Logs
  const filteredLogs = useMemo(() => {
    let result = logs;
    if (logFilter === "Unresolved") {
      result = logs.filter((l) => l.status === "Unresolved");
    } else if (logFilter === "Resolved") {
      result = logs.filter((l) => l.status === "Resolved");
    }
    return result;
  }, [logs, logFilter]);

  // Handle simulate error form submit
  const handleSimulateError = (e) => {
    e.preventDefault();
    if (!simMessage.trim()) return;

    simulateError(simUser, simComponent, simMessage, simSeverity);
    setSimMessage("");
    setSimSuccessMsg("Error log simulated successfully!");
    setTimeout(() => setSimSuccessMsg(""), 3000);
  };

  return (
    <div className="admin-dashboard">
      {/* Dashboard Header */}
      <div className="ad-header">
        <div>
          <h1>AcquireOS Admin Command Center</h1>
          <p>Global monitoring, deal validation audit logs, and user management portals</p>
        </div>
        {/* No ad-actions */}
      </div>

      {/* KPI Cards Grid */}
      <div className="ad-stats-grid">
        <div className="ad-stat-card blue">
          <div className="ad-stat-icon"><IconUsers size={22} /></div>
          <div className="ad-stat-info">
            <span className="ad-stat-label">Registered Users</span>
            <span className="ad-stat-value">{stats.totalUsers}</span>
            <span className="ad-stat-sub">Active login profiles</span>
          </div>
        </div>

        <div className="ad-stat-card emerald">
          <div className="ad-stat-icon"><IconCheckCircle size={22} /></div>
          <div className="ad-stat-info">
            <span className="ad-stat-label">Active Users</span>
            <span className="ad-stat-value">{stats.activeUsers}</span>
            <span className="ad-stat-sub">Approved & active</span>
          </div>
        </div>

        <div className="ad-stat-card violet">
          <div className="ad-stat-icon"><IconClock size={22} /></div>
          <div className="ad-stat-info">
            <span className="ad-stat-label">Pending Approvals</span>
            <span className="ad-stat-value">{stats.pendingApprovals}</span>
            <span className="ad-stat-sub">Awaiting review</span>
          </div>
        </div>

        <div className="ad-stat-card rose">
          <div className="ad-stat-icon"><IconAlertTriangle size={22} /></div>
          <div className="ad-stat-info">
            <span className="ad-stat-label">System Errors</span>
            <span className="ad-stat-value">{stats.unresolvedErrors}</span>
            <span className="ad-stat-sub">Requires resolution</span>
          </div>
        </div>
      </div>

      {/* Segmented Glass Tabs Switcher */}
      <div className="ad-tabs">
        <button
          className={`ad-tab ${activeTab === "overview" ? "active" : ""}`}
          onClick={() => setActiveTab("overview")}
        >
          <IconActivity size={16} /> Overview
        </button>
        <button
          className={`ad-tab ${activeTab === "users" ? "active" : ""}`}
          onClick={() => setActiveTab("users")}
        >
          <IconUsers size={16} /> User Directory
        </button>
        <button
          className={`ad-tab ${activeTab === "deals" ? "active" : ""}`}
          onClick={() => setActiveTab("deals")}
        >
          <IconShieldCheck size={16} /> Deal Validator
        </button>
        <button
          className={`ad-tab ${activeTab === "pipeline" ? "active" : ""}`}
          onClick={() => setActiveTab("pipeline")}
        >
          <IconMapPin size={16} /> Pipeline Tracker
        </button>
        <button
          className={`ad-tab ${activeTab === "logs" ? "active" : ""}`}
          onClick={() => setActiveTab("logs")}
        >
          <IconTerminal size={16} /> System Logs
          {stats.unresolvedErrors > 0 && (
            <span className="ad-tab-badge">{stats.unresolvedErrors}</span>
          )}
        </button>
      </div>

      {/* Main Tab Panel Render */}
      <div className="admin-dashboard-panel">
        <TabErrorBoundary tab={activeTab} key={activeTab}>
          {activeTab === "overview" && (
          <div className="ad-registration-overview">
            <h3 className="admin-dashboard-panel-title">Registration Overview</h3>
            <div className="ad-registration-grid">
                {[
                  { label: "Total Registered", value: stats.totalUsers, color: "#2563eb", icon: <IconUsers size={14} /> },
                  { label: "Active Accounts", value: stats.activeUsers, color: "#10b981", icon: <IconCheckCircle size={14} /> },
                  { label: "Pending Approval", value: stats.pendingApprovals, color: "#f59e0b", icon: <IconClock size={14} /> },
                  { label: "Unresolved Issues", value: stats.unresolvedErrors, color: "#ef4444", icon: <IconAlertTriangle size={14} /> },
                ].map(({ label, value, color, icon }) => {
                  const pct = stats.totalUsers > 0 ? Math.round((value / stats.totalUsers) * 100) : 0;
                  return (
                    <div className="ad-registration-item" key={label}>
                      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, fontWeight: 700 }}>
                        <span style={{ color: "#334155", display: "flex", alignItems: "center", gap: 6 }}>
                          {icon}
                          <span>{label}</span>
                        </span>
                        <span style={{ color }}>{value}</span>
                      </div>
                      <div style={{ width: "100%", height: 7, background: "#f1f5f9", borderRadius: 4, overflow: "hidden" }}>
                        <div style={{ width: `${Math.max(pct, value > 0 ? 4 : 0)}%`, height: "100%", background: color, borderRadius: 4, transition: "width 0.8s ease" }} />
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        )}

        {activeTab === "users" && (
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            {/* Tab header actions */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16, flexWrap: "wrap", background: "#f8fafc", padding: "12px 16px", borderRadius: 10, border: "1px solid #e2e8f0" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 13, fontWeight: 700, color: "#475569" }}>Account Type:</span>
                {["All", "Individual", "Organization"].map((type) => {
                  return (
                    <button
                      key={type}
                      style={{
                        background: userTypeFilter === type ? "#1e293b" : "transparent",
                        border: userTypeFilter === type ? "none" : "1px solid #cbd5e1",
                        color: userTypeFilter === type ? "#ffffff" : "#475569",
                        padding: "6px 14px",
                        borderRadius: 6,
                        fontSize: 12,
                        fontWeight: 600,
                        cursor: "pointer",
                        transition: "all 0.2s",
                      }}
                      onClick={() => setUserTypeFilter(type)}
                    >
                      {type === "All" ? "All Profiles" : type}
                    </button>
                  );
                })}
              </div>
              
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                {/* Sort Selector */}
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <span style={{ fontSize: 13, color: "#475569", fontWeight: 600 }}>Sort:</span>
                  <select
                    value={userSortOption}
                    onChange={(e) => setUserSortOption(e.target.value)}
                    style={{
                      padding: "8px 12px",
                      borderRadius: 8,
                      border: "1.5px solid #dbeafe",
                      background: "#fff",
                      fontSize: 13,
                      fontWeight: 600,
                      color: "#1e3a8a",
                      cursor: "pointer",
                      outline: "none"
                    }}
                  >
                    <option value="name_asc">Name (A-Z)</option>
                    <option value="name_desc">Name (Z-A)</option>
                    <option value="deals_desc">Deals (High to Low)</option>
                    <option value="deals_asc">Deals (Low to High)</option>
                    <option value="date_desc">Reg Date (Newest First)</option>
                    <option value="date_asc">Reg Date (Oldest First)</option>
                  </select>
                </div>

                <div className="ad-search-container" style={{ margin: 0 }}>
                  <input
                    type="text"
                    placeholder="Search user, email, company..."
                    className="ad-search-input"
                    value={userQuery}
                    onChange={(e) => setUserQuery(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Status Filter Tabs */}
            <div style={{ display: "flex", gap: 8, borderBottom: "1px solid #e2e8f0", paddingBottom: 10, overflowX: "auto" }}>
              {["All", "Pending", "Active", "Rejected", "Suspended"].map((status) => {
                const count = users.filter((u) => u.role !== "admin" && u.status === status).length;
                return (
                  <button
                    key={status}
                    className={`ad-tab-sub ${userStatusFilter === status ? "active" : ""}`}
                    style={{
                      background: userStatusFilter === status ? "rgba(59, 130, 246, 0.15)" : "transparent",
                      border: "none",
                      color: userStatusFilter === status ? "#3b82f6" : "#475569",
                      padding: "6px 14px",
                      borderRadius: 6,
                      fontSize: 13,
                      fontWeight: 600,
                      cursor: "pointer",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                      whiteSpace: "nowrap"
                    }}
                    onClick={() => setUserStatusFilter(status)}
                  >
                    {status}
                    {status === "Pending" && count > 0 ? (
                      <span style={{ background: "#ef4444", color: "#fff", padding: "2px 6px", borderRadius: 10, fontSize: 10, fontWeight: 700 }}>
                        {count}
                      </span>
                    ) : (
                      <span style={{ opacity: 0.4, fontSize: 11 }}>({status === "All" ? users.filter((u) => u.role !== "admin").length : count})</span>
                    )}
                  </button>
                );
              })}
            </div>

            {/* Table */}
            <div className="ad-table-wrapper">
              <table className="ad-table">
                <thead>
                  {userTypeFilter === "All" && (
                    <tr>
                      <th>User / Client</th>
                      <th>Account Type</th>
                      <th>Company / Org Name</th>
                      <th>Profile Details</th>
                      <th>Deals Submitted</th>
                      <th>Registration Date</th>
                      <th>Status</th>
                      <th style={{ textAlign: "right" }}>Management Actions</th>
                    </tr>
                  )}
                  {userTypeFilter === "Individual" && (
                    <tr>
                      <th>User / Client</th>
                      <th>Investment Strategy</th>
                      <th>Target Deal Size</th>
                      <th>Accredited Status</th>
                      <th>Deals Submitted</th>
                      <th>Registration Date</th>
                      <th>Status</th>
                      <th style={{ textAlign: "right" }}>Management Actions</th>
                    </tr>
                  )}
                  {userTypeFilter === "Organization" && (
                    <tr>
                      <th>User / Client</th>
                      <th>Org Name</th>
                      <th>Website URL</th>
                      <th>Org Details</th>
                      <th>Deals Submitted</th>
                      <th>Registration Date</th>
                      <th>Status</th>
                      <th style={{ textAlign: "right" }}>Management Actions</th>
                    </tr>
                  )}
                </thead>
                <tbody>
                  {filteredUsers.map((user) => {
                    const dCount = deals.filter((d) => d.userEmail === user.email).length;
                    const dateStr = user.registeredAt ? new Date(user.registeredAt).toLocaleDateString() : "N/A";
                    return (
                      <tr key={user.id}>
                        <td>
                          <div className="ad-user-cell" style={{ cursor: 'pointer' }} onClick={() => setSelectedUserProfile(user)}>
                            <span className="ad-user-name" style={{ color: '#2563eb', textDecoration: 'underline', textDecorationStyle: 'dotted' }}>{user.name}</span>
                            <span className="ad-user-email">{user.email}</span>
                          </div>
                        </td>
                        
                        {userTypeFilter === "All" && (
                          <>
                            <td>
                              <span style={{ 
                                textTransform: 'capitalize', 
                                background: user.userType === 'organization' ? 'rgba(139, 92, 246, 0.12)' : 'rgba(59, 130, 246, 0.12)', 
                                color: user.userType === 'organization' ? '#7c3aed' : '#2563eb', 
                                padding: '2px 8px', 
                                borderRadius: 4, 
                                fontSize: 11, 
                                fontWeight: 700 
                              }}>
                                {user.userType || 'individual'}
                              </span>
                            </td>
                            <td>{user.userType === 'organization' ? (user.orgName || user.company || "N/A") : (user.company || "N/A")}</td>
                            <td style={{ fontSize: 12.5, color: '#475569' }}>
                              {user.userType === 'organization' ? (
                                user.orgUrl ? <a href={user.orgUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb' }}>{user.orgUrl}</a> : "N/A"
                              ) : (
                                user.indStrategy || "N/A"
                              )}
                            </td>
                          </>
                        )}
                        
                        {userTypeFilter === "Individual" && (
                          <>
                            <td style={{ fontSize: 13, color: '#334155', fontWeight: 500 }}>{user.indStrategy || "N/A"}</td>
                            <td style={{ fontSize: 13, color: '#334155', fontWeight: 500 }}>{user.indDealSize || "N/A"}</td>
                            <td>
                              <span style={{ 
                                background: user.indAccredited?.includes('Non-') ? 'rgba(239, 68, 68, 0.1)' : 'rgba(16, 185, 129, 0.1)', 
                                color: user.indAccredited?.includes('Non-') ? '#ef4444' : '#10b981', 
                                padding: '2px 8px', 
                                borderRadius: 4, 
                                fontSize: 11, 
                                fontWeight: 700 
                              }}>
                                {user.indAccredited || "N/A"}
                              </span>
                            </td>
                          </>
                        )}
                        
                        {userTypeFilter === "Organization" && (
                          <>
                            <td style={{ fontWeight: 600 }}>{user.orgName || user.company || "N/A"}</td>
                            <td>
                              {user.orgUrl ? (
                                <a href={user.orgUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb', textDecoration: 'underline' }}>
                                  {user.orgUrl}
                                </a>
                              ) : "N/A"}
                            </td>
                            <td style={{ fontSize: 12.5, color: '#475569', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {user.orgDetails || "N/A"}
                            </td>
                          </>
                        )}

                        <td>
                          <span style={{ fontWeight: 700, color: "#2563eb" }}>{dCount}</span>
                        </td>
                        <td>{dateStr}</td>
                        <td>
                          <span className={`ad-badge ${user.status.toLowerCase()}`}>
                            {user.status}
                          </span>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                            {user.status === "Pending" && (
                              <>
                                <button
                                  className="ad-btn-icon success"
                                  onClick={() => handleApproveUser(user)}
                                  style={{ padding: "6px 12px", fontSize: 12, background: "rgba(16, 185, 129, 0.15)", color: "#10b981", border: "1px solid rgba(16, 185, 129, 0.3)", display: "inline-flex", alignItems: "center", gap: 4 }}
                                >
                                  <IconCheckCircle size={12} />
                                  <span>Approve</span>
                                </button>
                                <button
                                  className="ad-btn-icon danger"
                                  onClick={() => handleRejectUserClick(user)}
                                  style={{ padding: "6px 12px", fontSize: 12, background: "rgba(239, 68, 68, 0.15)", color: "#ef4444", border: "1px solid rgba(239, 68, 68, 0.3)", display: "inline-flex", alignItems: "center", gap: 4 }}
                                >
                                  <IconCrossCircle size={12} />
                                  <span>Reject</span>
                                </button>
                              </>
                            )}
                            {user.status === "Active" && (
                              <button
                                className="ad-btn-icon"
                                onClick={() => handleSuspendUser(user)}
                                style={{ padding: "6px 12px", fontSize: 12, background: "rgba(37, 99, 235, 0.15)", color: "#2563eb", border: "1px solid rgba(37, 99, 235, 0.3)", borderRadius: "8px", fontWeight: "600", cursor: "pointer" }}
                              >
                                Suspend
                              </button>
                            )}
                            {user.status === "Suspended" && (
                              <button
                                className="ad-btn-icon"
                                onClick={() => handleApproveUser(user, true)}
                                style={{ padding: "6px 12px", fontSize: 12, background: "rgba(37, 99, 235, 0.15)", color: "#2563eb", border: "1px solid rgba(37, 99, 235, 0.3)", borderRadius: "8px", fontWeight: "600", cursor: "pointer" }}
                              >
                                Activate
                              </button>
                            )}
                            <button
                              className="ad-btn-icon"
                              onClick={() => handleDeleteUser(user)}
                              style={{ padding: "6px 8px", background: "rgba(37, 99, 235, 0.1)", color: "#2563eb", border: "1px solid rgba(37, 99, 235, 0.25)", display: "inline-flex", alignItems: "center", justifyContent: "center", borderRadius: "8px", cursor: "pointer" }}
                              title="Delete user entry permanently"
                            >
                              <IconTrash size={14} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                  {filteredUsers.length === 0 && (
                    <tr>
                      <td colSpan="8" style={{ textAlign: "center", padding: 40 }}>
                        <div className="ad-empty-state">
                          <IconSearch size={32} style={{ color: "#94a3b8", marginBottom: 12, display: "block", marginLeft: "auto", marginRight: "auto" }} />
                          <span className="ad-empty-title">No users matched your query.</span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {activeTab === "deals" && (
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            {/* Header */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h3 style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>Deal Audit & Verification</h3>
              <div className="ad-search-container">

                <input
                  type="text"
                  placeholder="Search deal name, user..."
                  className="ad-search-input"
                  value={dealQuery}
                  onChange={(e) => setDealQuery(e.target.value)}
                />
              </div>
            </div>

            {/* Table */}
            <div className="ad-table-wrapper">
              <table className="ad-table">
                <thead>
                  <tr>
                    <th>Deal Name</th>
                    <th>Submitted By</th>
                    <th>Valuation</th>
                    <th>Units</th>
                    <th>Cap Rate</th>
                    <th>Audit Status</th>
                    <th style={{ textAlign: "right" }}>Audit Controls</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredDeals.map((deal) => {
                    const isClosed = deal.status === "Validated" || deal.status === "Rejected";
                    return (
                      <tr key={deal.id}>
                        <td>
                          <span
                            onClick={() => setSelectedDealDetails(deal)}
                            style={{ fontWeight: 700, color: "#2563eb", textDecoration: "underline", textDecorationStyle: "dotted", cursor: "pointer" }}
                            title="Click to view details and documents"
                          >
                            {deal.name}
                          </span>
                        </td>
                        <td style={{ color: "#2563eb", fontSize: 12 }}>{deal.userEmail}</td>
                        <td>{formatCurrency(deal.price)}</td>
                        <td>{deal.units} units</td>
                        <td>{deal.capRate}%</td>
                        <td>
                          <span className={`ad-badge ${deal.status.toLowerCase().replace(" ", "-")}`}>
                            {deal.status}
                          </span>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <div className="ad-action-group" style={{ justifyContent: "flex-end" }}>
                            <button
                                className={`ad-btn-icon success ${isClosed ? "disabled" : ""}`}
                                onClick={() => validateDeal(deal.id, "Validated")}
                                disabled={isClosed}
                                title={isClosed ? "Status finalized" : "Mark as Validated"}
                                style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
                            >
                              <IconCheckCircle size={12} />
                              <span>Validate</span>
                            </button>
                            <button
                                className={`ad-btn-icon danger ${isClosed ? "disabled" : ""}`}
                                onClick={() => validateDeal(deal.id, "Rejected")}
                                disabled={isClosed}
                                title={isClosed ? "Status finalized" : "Mark as Rejected"}
                                style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
                            >
                              <IconCrossCircle size={12} />
                              <span>Reject</span>
                            </button>
                            <button
                              className="ad-btn-icon danger"
                              onClick={() => {
                                confirm({
                                  title: 'Delete Deal',
                                  message: `Are you sure you want to permanently delete "${deal.name}"?`,
                                  type: 'danger',
                                  confirmText: 'Delete Deal',
                                  onConfirm: () => deleteDeal(deal.id)
                                });
                              }}
                              style={{ background: "rgba(239, 68, 68, 0.15)", color: "#ef4444", border: "1px solid rgba(239, 68, 68, 0.3)", display: "inline-flex", alignItems: "center", gap: 4 }}
                              title="Delete Deal"
                            >
                              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ display: "inline-block" }}>
                                <polyline points="3 6 5 6 21 6"></polyline>
                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                <line x1="10" y1="11" x2="10" y2="17"></line>
                                <line x1="14" y1="11" x2="14" y2="17"></line>
                              </svg>
                              <span>Delete</span>
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                  {filteredDeals.length === 0 && (
                    <tr>
                      <td colSpan="7" style={{ textAlign: "center", padding: 40 }}>
                        <div className="ad-empty-state">
                          <IconSearch size={32} style={{ color: "#94a3b8", marginBottom: 12, display: "block", marginLeft: "auto", marginRight: "auto" }} />
                          <span className="ad-empty-title">No deals found matching your search.</span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {activeTab === "pipeline" && (
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h3 style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>User Pipeline Tracker</h3>
              <div style={{ fontSize: 13, color: "#64748b" }}>
                Monitor active user progression through the 1-16 acquisition modules
              </div>
            </div>

            <div className="ad-table-wrapper">
              <table className="ad-table">
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Active Deal</th>
                    <th>Current Stage</th>
                    <th>Progress</th>
                    <th style={{ textAlign: "right" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {users.filter(u => u.role !== "admin").map((user) => {
                    const userDeals = deals.filter(d => d.userEmail === user.email);
                    const activeDeal = userDeals[0]; // pick their most recent active deal
                    const stageNum = activeDeal ? getStageNumber(activeDeal.stage) : 0;
                    const progressPct = activeDeal ? Math.round((stageNum / 16) * 100) : 0;
                    const stageName = activeDeal ? getStageName(stageNum) : "Not Started";

                    return (
                      <tr key={user.id}>
                        <td>
                          <div style={{ display: "flex", flexDirection: "column" }}>
                            <span style={{ fontWeight: 700, color: "#0f172a" }}>{user.name}</span>
                            <span style={{ fontSize: 11, color: "#64748b" }}>{user.email}</span>
                          </div>
                        </td>
                        <td>
                          {activeDeal ? (
                            <div style={{ display: "flex", flexDirection: "column" }}>
                              <span style={{ fontWeight: 600, color: "#334155" }}>{activeDeal.name}</span>
                              <span style={{ fontSize: 11, color: "#94a3b8" }}>Valuation: {formatCurrency(activeDeal.price)}</span>
                            </div>
                          ) : (
                            <span style={{ color: "#94a3b8", fontStyle: "italic" }}>No active deal</span>
                          )}
                        </td>
                        <td>
                          {activeDeal ? (
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                              <span style={{ background: "#eff6ff", color: "#1d4ed8", padding: "4px 8px", borderRadius: 6, fontSize: 12, fontWeight: 700 }}>
                                Stage {stageNum}/16
                              </span>
                              <span style={{ fontSize: 12, color: "#475569", fontWeight: 500 }}>
                                {stageName}
                              </span>
                            </div>
                          ) : (
                            <span style={{ color: "#94a3b8" }}>—</span>
                          )}
                        </td>
                        <td>
                          <div style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", maxWidth: 180 }}>
                            <div style={{ flex: 1, height: 6, background: "#e2e8f0", borderRadius: 3, overflow: "hidden" }}>
                              <div style={{ width: `${progressPct}%`, height: "100%", background: "linear-gradient(90deg, #3b82f6, #2563eb)", borderRadius: 3 }} />
                            </div>
                            <span style={{ fontSize: 11, fontWeight: 700, color: "#475569", minWidth: 28 }}>{progressPct}%</span>
                          </div>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <button
                            className="ad-btn-secondary"
                            style={{ padding: "6px 12px", fontSize: 12 }}
                            onClick={() => setSelectedUserProfile(user)}
                          >
                            Inspect Profile
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                  {users.filter(u => u.role !== "admin").length === 0 && (
                    <tr>
                      <td colSpan="5" style={{ textAlign: "center", padding: 40 }}>
                        <div className="ad-empty-state">
                          <IconUsers size={32} style={{ color: "#94a3b8", marginBottom: 12, display: "block", marginLeft: "auto", marginRight: "auto" }} />
                          <span className="ad-empty-title">No users registered in the system yet.</span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {activeTab === "logs" && (
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            {/* Header */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h3 style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>System Logs & Errors</h3>
              <div style={{ display: "flex", gap: 8 }}>
                <button
                  className={`ad-btn-secondary ${logFilter === "All" ? "ad-btn-primary" : ""}`}
                  style={{ padding: "6px 12px", fontSize: 12 }}
                  onClick={() => setLogFilter("All")}
                >
                  All Logs
                </button>
                <button
                  className={`ad-btn-secondary ${logFilter === "Unresolved" ? "ad-btn-primary" : ""}`}
                  style={{ padding: "6px 12px", fontSize: 12 }}
                  onClick={() => setLogFilter("Unresolved")}
                >
                  Unresolved
                </button>
                <button
                  className={`ad-btn-secondary ${logFilter === "Resolved" ? "ad-btn-primary" : ""}`}
                  style={{ padding: "6px 12px", fontSize: 12 }}
                  onClick={() => setLogFilter("Resolved")}
                >
                  Resolved
                </button>
              </div>
            </div>

            {/* List */}
            <div className="ad-logs-list">
              {filteredLogs.map((log) => (
                <div
                  key={log.id}
                  className={`ad-log-item ${log.status === "Resolved" ? "resolved" : ""}`}
                >
                  <div className="ad-log-content">
                    <div className="ad-log-meta">
                      <span className="ad-log-time">{new Date(log.timestamp).toLocaleString()}</span>
                      <span className="ad-log-user">{log.userEmail}</span>
                      <span className="ad-log-component">{log.component}</span>
                      <span className={`ad-badge severity-${log.severity.toLowerCase()}`}>
                        {log.severity} Severity
                      </span>
                    </div>
                    <div className="ad-log-message">{log.message}</div>
                  </div>
                  <div>
                    {log.status === "Unresolved" ? (
                      <button
                        className="ad-btn-icon success"
                        onClick={() => resolveLog(log.id)}
                        style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
                      >
                        <IconCheckCircle size={12} />
                        <span>Resolve Exception</span>
                      </button>
                    ) : (
                      <span style={{ fontSize: 12, fontWeight: 700, color: "#10b981", display: "inline-flex", gap: 4, alignItems: "center" }}>
                        <IconCheckCircle size={12} />
                        <span>Resolved</span>
                      </span>
                    )}
                  </div>
                </div>
              ))}

              {filteredLogs.length === 0 && (
                <div className="ad-empty-state">
                  <IconCheckCircle size={32} style={{ color: "#10b981", marginBottom: 12, display: "block", marginLeft: "auto", marginRight: "auto" }} />
                  <span className="ad-empty-title">All logs resolved! System health is fully optimal.</span>
                </div>
              )}
            </div>


            {simSuccessMsg && (
              <div style={{ fontSize: 13, fontWeight: 600, color: "#0ca678", textAlign: "center", marginTop: 4 }}>
                {simSuccessMsg}
              </div>
            )}
          </div>
        )}
        </TabErrorBoundary>
      </div>

      {/* Rejection Reason Selector Modal */}
      {selectedUserForRejection && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(15, 23, 42, 0.75)',
          backdropFilter: 'blur(4px)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
          padding: 20
        }}>
          <div className="ad-card" style={{
            width: '100%',
            maxWidth: 480,
            background: '#ffffff',
            border: '1px solid #e2e8f0',
            borderRadius: 16,
            padding: 24,
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.15), 0 10px 10px -5px rgba(0, 0, 0, 0.1)'
          }}>
            <h3 style={{ fontSize: 18, fontWeight: 700, color: '#0f172a', margin: '0 0 12px 0' }}>
              Select Rejection Reason
            </h3>
            <p style={{ fontSize: 14, color: '#475569', marginBottom: 20 }}>
              Please choose a reason for rejecting the registration request of <strong style={{ color: '#0f172a' }}>{selectedUserForRejection.name}</strong>.
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 24 }}>
              {REJECTION_REASONS.map((reason) => (
                <label
                  key={reason}
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 10,
                    padding: 12,
                    background: selectedRejectionReason === reason ? 'rgba(59, 130, 246, 0.08)' : '#f8fafc',
                    border: selectedRejectionReason === reason ? '1px solid #3b82f6' : '1px solid #e2e8f0',
                    borderRadius: 8,
                    cursor: 'pointer',
                    fontSize: 13,
                    color: selectedRejectionReason === reason ? '#2563eb' : '#334155',
                    textAlign: 'left',
                    transition: 'all 0.2s'
                  }}
                >
                  <input
                    type="radio"
                    name="rejection-reason"
                    value={reason}
                    checked={selectedRejectionReason === reason}
                    onChange={() => setSelectedRejectionReason(reason)}
                    style={{ marginTop: 2 }}
                  />
                  <span>{reason}</span>
                </label>
              ))}
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
              <button
                className="ad-btn-secondary"
                onClick={() => setSelectedUserForRejection(null)}
                style={{ padding: '8px 16px', fontSize: 13 }}
              >
                Cancel
              </button>
              <button
                className="ad-btn-icon danger"
                onClick={handleConfirmRejection}
                style={{ padding: '8px 16px', fontSize: 13, background: '#ef4444', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}
              >
                Confirm Rejection
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Email Notification Preview Modal */}
      {emailNotification && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(15, 23, 42, 0.75)',
          backdropFilter: 'blur(4px)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1001,
          padding: 20
        }}>
          <div className="ad-card" style={{
            width: '100%',
            maxWidth: 550,
            background: '#ffffff',
            borderRadius: 16,
            padding: 24,
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3), 0 10px 10px -5px rgba(0, 0, 0, 0.25)',
            color: '#1e293b'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#2563eb' }}>
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <span>Outgoing Notification Email Preview</span>
              </h3>
              <span style={{ fontSize: 11, background: '#e0f2fe', color: '#0369a1', padding: '2px 8px', borderRadius: 10, fontWeight: 600 }}>
                Sent in Dev Mode
              </span>
            </div>

            <div style={{
              background: '#f8fafc',
              border: '1px solid #e2e8f0',
              borderRadius: 8,
              padding: 16,
              marginBottom: 20,
              fontFamily: 'monospace',
              fontSize: 12,
              textAlign: 'left'
            }}>
              <div><strong style={{ color: '#64748b' }}>To:</strong> {emailNotification.to}</div>
              <div style={{ margin: '6px 0' }}><strong style={{ color: '#64748b' }}>Subject:</strong> {emailNotification.subject}</div>
              <hr style={{ border: 'none', borderTop: '1px solid #e2e8f0', margin: '12px 0' }} />
              <div style={{ whiteSpace: 'pre-wrap', color: '#334155', lineHeight: '1.6' }}>
                {emailNotification.body}
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button
                className="ad-btn-icon success"
                onClick={() => setEmailNotification(null)}
                style={{ padding: '8px 20px', fontSize: 13, background: '#10b981', color: '#ffffff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}
              >
                Okay, Close
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ── User Profile Drawer ─────────────────────────────────────── */}
      {selectedUserProfile && (() => {
        const u = selectedUserProfile;
        const userDeals = deals.filter(d => d.userEmail === u.email);
        const totalValue = userDeals.reduce((sum, d) => sum + (d.price || 0), 0);
        const activeDeals = userDeals.filter(d => !['Closed', 'Rejected', 'Withdrawn'].includes(d.stage)).length;
        const validatedDeals = userDeals.filter(d => d.status === 'Validated').length;
        const initials = u.name ? u.name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase() : '?';
        const statusColors = { Active: '#10b981', Pending: '#f59e0b', Rejected: '#ef4444', Suspended: '#64748b' };
        const statusColor = statusColors[u.status] || '#64748b';

        return (
          <>
            <div className="upd-backdrop" onClick={() => setSelectedUserProfile(null)} />
            <aside className="upd-drawer">
              {/* Header */}
              <div className="upd-header">
                <button className="upd-close" onClick={() => setSelectedUserProfile(null)}>✕</button>
                <div className="upd-avatar">{initials}</div>
                <h2 className="upd-name">{u.name}</h2>
                <p className="upd-email">{u.email}</p>
                <div className="upd-meta-row">
                  {u.company && u.company !== 'N/A' && (
                    <span className="upd-company-pill" style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                      <IconBuilding size={12} />
                      <span>{u.company}</span>
                    </span>
                  )}
                  <span style={{ background: statusColor + '22', border: `1px solid ${statusColor}55`, color: statusColor, borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 700 }}>
                    {u.status}
                  </span>
                  <span className="upd-company-pill">Buyer / Investor</span>
                </div>
              </div>

              {/* Body */}
              <div className="upd-body">

                {/* KPI Cards */}
                <div>
                  <p className="upd-section-title">Activity Overview</p>
                  <div className="upd-kpi-grid">
                    <div className="upd-kpi-card accent-blue">
                      <span className="upd-kpi-label">Total Deals</span>
                      <span className="upd-kpi-value">{userDeals.length}</span>
                      <span className="upd-kpi-sub">Submitted to platform</span>
                    </div>
                    <div className="upd-kpi-card accent-green">
                      <span className="upd-kpi-label">Total Value</span>
                      <span className="upd-kpi-value" style={{ fontSize: userDeals.length ? 16 : 22 }}>
                        {totalValue > 0 ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', notation: 'compact', maximumFractionDigits: 1 }).format(totalValue) : '—'}
                      </span>
                      <span className="upd-kpi-sub">Across all deals</span>
                    </div>
                    <div className="upd-kpi-card accent-amber">
                      <span className="upd-kpi-label">In Pipeline</span>
                      <span className="upd-kpi-value">{activeDeals}</span>
                      <span className="upd-kpi-sub">Active deals</span>
                    </div>
                    <div className="upd-kpi-card accent-violet">
                      <span className="upd-kpi-label">Validated</span>
                      <span className="upd-kpi-value">{validatedDeals}</span>
                      <span className="upd-kpi-sub">Admin-approved deals</span>
                    </div>
                  </div>
                </div>

                {/* Deal History */}
                <div>
                  <p className="upd-section-title">Deal History</p>
                  {userDeals.length === 0 ? (
                    <div className="upd-empty" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
                      <IconFolderOpen size={32} style={{ color: '#94a3b8', marginBottom: 12 }} />
                      <span>No deals submitted yet by this user.</span>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                      {userDeals.map(deal => {
                        const dStatusColor = deal.status === 'Validated' ? '#10b981' : deal.status === 'Rejected' ? '#ef4444' : '#f59e0b';
                        return (
                          <div key={deal.id} className="upd-deal-card">
                            <div className="upd-deal-top">
                              <span className="upd-deal-name">{deal.name}</span>
                              <span style={{ background: dStatusColor + '18', color: dStatusColor, border: `1px solid ${dStatusColor}44`, borderRadius: 6, padding: '2px 8px', fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap' }}>
                                {deal.status}
                              </span>
                            </div>
                            <div className="upd-deal-stats">
                              <span className="upd-deal-stat" style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                                <IconDollar size={12} />
                                <strong>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(deal.price || 0)}</strong>
                              </span>
                              {deal.units > 0 && (
                                <span className="upd-deal-stat" style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                                  <IconHome size={12} />
                                  <strong>{deal.units} units</strong>
                                </span>
                              )}
                              {deal.capRate > 0 && (
                                <span className="upd-deal-stat" style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                                  <IconTrendingUp size={12} />
                                  <strong>{deal.capRate}% cap</strong>
                                </span>
                              )}
                            </div>
                            <div className="upd-deal-footer">
                              <span className="upd-stage-pill">{deal.stage}</span>
                              <span className="upd-deal-date">{deal.submittedAt ? new Date(deal.submittedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : 'N/A'}</span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>

                {/* Profile Details */}
                <div>
                  <p className="upd-section-title">Investor Profile ({u.userType === 'organization' ? 'Organization' : 'Individual'})</p>
                  {u.userType === 'organization' ? (
                    <div className="upd-info-grid">
                      <div className="upd-info-item" style={{ gridColumn: 'span 2' }}>
                        <span className="upd-info-label">Organization Name</span>
                        <span className="upd-info-value" style={{ fontWeight: 600 }}>{u.orgName || u.company || 'N/A'}</span>
                      </div>
                      <div className="upd-info-item" style={{ gridColumn: 'span 2' }}>
                        <span className="upd-info-label">Website URL</span>
                        <span className="upd-info-value">
                          {u.orgUrl ? <a href={u.orgUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb', textDecoration: 'underline' }}>{u.orgUrl}</a> : 'N/A'}
                        </span>
                      </div>
                      <div className="upd-info-item" style={{ gridColumn: 'span 2' }}>
                        <span className="upd-info-label">Company Details</span>
                        <span className="upd-info-value" style={{ whiteSpace: 'pre-wrap', lineHeight: '1.4', fontSize: 12.5 }}>{u.orgDetails || 'N/A'}</span>
                      </div>
                    </div>
                  ) : (
                    <div className="upd-info-grid">
                      <div className="upd-info-item">
                        <span className="upd-info-label">Investment Strategy</span>
                        <span className="upd-info-value">{u.indStrategy || 'N/A'}</span>
                      </div>
                      <div className="upd-info-item">
                        <span className="upd-info-label">Target Deal Size</span>
                        <span className="upd-info-value">{u.indDealSize || 'N/A'}</span>
                      </div>
                      <div className="upd-info-item" style={{ gridColumn: 'span 2' }}>
                        <span className="upd-info-label">Accreditation Status</span>
                        <span className="upd-info-value" style={{ 
                          color: u.indAccredited?.includes('Non-') ? '#ef4444' : '#10b981', 
                          fontWeight: 700 
                        }}>
                          {u.indAccredited || 'N/A'}
                        </span>
                      </div>
                    </div>
                  )}
                </div>

                {/* Account Info */}
                <div>
                  <p className="upd-section-title">Account Information</p>
                  <div className="upd-info-grid">
                    <div className="upd-info-item">
                      <span className="upd-info-label">Member Since</span>
                      <span className="upd-info-value">{u.registeredAt ? new Date(u.registeredAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'N/A'}</span>
                    </div>
                    <div className="upd-info-item">
                      <span className="upd-info-label">Account Status</span>
                      <span className="upd-info-value" style={{ color: statusColor }}>{u.status}</span>
                    </div>
                    <div className="upd-info-item">
                      <span className="upd-info-label">Company</span>
                      <span className="upd-info-value">{u.company || 'N/A'}</span>
                    </div>
                    <div className="upd-info-item">
                      <span className="upd-info-label">User ID</span>
                      <span className="upd-info-value" style={{ fontSize: 11, fontFamily: 'monospace', color: '#64748b' }}>{u.id}</span>
                    </div>
                  </div>
                </div>

              </div>
            </aside>
          </>
        );
      })()}

      {/* ── Deal Details Modal ───────────────────────────────────────── */}
      {selectedDealDetails && (() => {
        const deal = selectedDealDetails;
        const dealStatusColor = deal.status === 'Validated' ? '#10b981' : deal.status === 'Rejected' ? '#ef4444' : '#f59e0b';
        const meta = deal.metadata || {};
        const assumptions = meta.assumptions || {};
        const metrics = meta.metrics || {};
        const docsList = [
          { name: "Offering Memorandum (OM)", type: "PDF Document", uploaded: !!meta.omUploaded },
          { name: "Rent Roll (Multifamily / Tenant Mix)", type: "Excel Spreadsheet", uploaded: !!meta.rentRollUploaded },
          { name: "T12 Financial Statement (Trailer 12 Months)", type: "Excel Spreadsheet", uploaded: !!meta.t12Uploaded }
        ];
        return (
          <>
            <div className="ddm-backdrop" onClick={() => setSelectedDealDetails(null)} />
            <div className="ddm-modal">
              <div className="ddm-header">
                <h3 className="ddm-title" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <IconSearch size={18} style={{ color: '#2563eb' }} />
                  <span>Deal Audit Details</span>
                </h3>
                <button className="ddm-close" onClick={() => setSelectedDealDetails(null)}>✕</button>
              </div>
              <div className="ddm-body">
                {/* General Info */}
                <div className="ddm-section">
                  <p className="ddm-section-title">General Property Information</p>
                  <div className="ddm-info-grid">
                    <div className="ddm-info-item">
                      <span className="ddm-info-label">Deal Name</span>
                      <span className="ddm-info-value">{deal.name}</span>
                    </div>
                    <div className="ddm-info-item">
                      <span className="ddm-info-label">Submitted By</span>
                      <span className="ddm-info-value" style={{ color: "#2563eb" }}>{deal.userEmail}</span>
                    </div>
                    <div className="ddm-info-item">
                      <span className="ddm-info-label">Valuation</span>
                      <span className="ddm-info-value">{formatCurrency(deal.price)}</span>
                    </div>
                    <div className="ddm-info-item">
                      <span className="ddm-info-label">Unit Count</span>
                      <span className="ddm-info-value">{deal.units} units</span>
                    </div>
                    <div className="ddm-info-item">
                      <span className="ddm-info-label">Cap Rate</span>
                      <span className="ddm-info-value">{deal.capRate}%</span>
                    </div>
                    <div className="ddm-info-item">
                      <span className="ddm-info-label">Audit Status</span>
                      <span className="ddm-info-value" style={{ color: dealStatusColor }}>{deal.status}</span>
                    </div>
                  </div>
                </div>

                {/* Underwriting Assumptions */}
                <div className="ddm-section">
                  <p className="ddm-section-title">Underwriting Assumptions (Stage 4 Inputs)</p>
                  <div className="ddm-info-grid">
                    <div className="ddm-info-item">
                      <span className="ddm-info-label">Interest Rate</span>
                      <span className="ddm-info-value">{assumptions.interestRate !== null && assumptions.interestRate !== undefined ? `${assumptions.interestRate}%` : 'N/A'}</span>
                    </div>
                    <div className="ddm-info-item">
                      <span className="ddm-info-label">Loan-To-Value (LTV)</span>
                      <span className="ddm-info-value">{assumptions.ltv !== null && assumptions.ltv !== undefined ? `${assumptions.ltv}%` : 'N/A'}</span>
                    </div>
                    <div className="ddm-info-item">
                      <span className="ddm-info-label">Loan Amount</span>
                      <span className="ddm-info-value">{assumptions.loanAmount !== null && assumptions.loanAmount !== undefined ? formatCurrency(assumptions.loanAmount) : 'N/A'}</span>
                    </div>
                    <div className="ddm-info-item">
                      <span className="ddm-info-label">Vacancy Rate</span>
                      <span className="ddm-info-value">{assumptions.vacancyRate !== null && assumptions.vacancyRate !== undefined ? `${assumptions.vacancyRate}%` : 'N/A'}</span>
                    </div>
                    <div className="ddm-info-item">
                      <span className="ddm-info-label">Rent Growth / yr</span>
                      <span className="ddm-info-value">{assumptions.rentGrowthRate !== null && assumptions.rentGrowthRate !== undefined ? `${assumptions.rentGrowthRate}%` : 'N/A'}</span>
                    </div>
                    <div className="ddm-info-item">
                      <span className="ddm-info-label">Expense Growth / yr</span>
                      <span className="ddm-info-value">{assumptions.expenseGrowthRate !== null && assumptions.expenseGrowthRate !== undefined ? `${assumptions.expenseGrowthRate}%` : 'N/A'}</span>
                    </div>
                  </div>
                </div>

                {/* Calculated Financial Metrics */}
                <div className="ddm-section">
                  <p className="ddm-section-title">Calculated Financial Metrics (Stage 4 Outputs)</p>
                  <div className="ddm-info-grid">
                    <div className="ddm-info-item">
                      <span className="ddm-info-label">Net Operating Income (NOI)</span>
                      <span className="ddm-info-value">{metrics.noi !== null && metrics.noi !== undefined ? `${formatCurrency(metrics.noi)} / yr` : 'N/A'}</span>
                    </div>
                    <div className="ddm-info-item">
                      <span className="ddm-info-label">Debt Service Coverage (DSCR)</span>
                      <span className="ddm-info-value">{metrics.dscrCurrent !== null && metrics.dscrCurrent !== undefined ? `${metrics.dscrCurrent}x` : 'N/A'}</span>
                    </div>
                    <div className="ddm-info-item">
                      <span className="ddm-info-label">Cash-on-Cash Return</span>
                      <span className="ddm-info-value">
                        {metrics.cashOnCashYear1 !== null && metrics.cashOnCashYear1 !== undefined ? `${metrics.cashOnCashYear1}% (Yr 1)` : 'N/A'}
                        {metrics.cashOnCashAverage !== null && metrics.cashOnCashAverage !== undefined ? ` / ${metrics.cashOnCashAverage}% (Avg)` : ''}
                      </span>
                    </div>
                    <div className="ddm-info-item">
                      <span className="ddm-info-label">Levered / Unlevered IRR</span>
                      <span className="ddm-info-value">
                        {metrics.irrLevered !== null && metrics.irrLevered !== undefined ? `${metrics.irrLevered}% (Lev)` : 'N/A'}
                        {metrics.irrUnlevered !== null && metrics.irrUnlevered !== undefined ? ` / ${metrics.irrUnlevered}% (Unlev)` : ''}
                      </span>
                    </div>
                    <div className="ddm-info-item">
                      <span className="ddm-info-label">Break-Even Occupancy</span>
                      <span className="ddm-info-value">{metrics.breakEvenOccupancy !== null && metrics.breakEvenOccupancy !== undefined ? `${metrics.breakEvenOccupancy}%` : 'N/A'}</span>
                    </div>
                    <div className="ddm-info-item">
                      <span className="ddm-info-label">Deal Score (Stage 5)</span>
                      <span className="ddm-info-value" style={{ fontWeight: 700, color: "#2563eb" }}>
                        {meta.dealScore !== null && meta.dealScore !== undefined ? `${meta.dealScore}/100 (${meta.dealVerdict || 'Under Review'})` : 'Awaiting Score'}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Uploaded Documents List */}
                <div className="ddm-section">
                  <p className="ddm-section-title">Uploaded Audit Documents</p>
                  <div className="ddm-doc-list">
                    {docsList.map((doc) => (
                      <div key={doc.name} className="ddm-doc-item">
                        <div className="ddm-doc-name">
                          <IconFileText size={18} style={{ color: "#64748b", flexShrink: 0 }} />
                          <div>
                            <div style={{ fontWeight: 600, color: "#334155" }}>{doc.name}</div>
                            <div style={{ fontSize: 11, color: "#64748b" }}>{doc.type}</div>
                          </div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                          {doc.uploaded ? (
                            <>
                              <span className="ddm-doc-badge" style={{ backgroundColor: "#dcfce7", color: "#15803d", padding: "4px 8px", borderRadius: 4, fontSize: 11, fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 4 }}>
                                <IconCheckCircle size={10} style={{ color: "#15803d" }} />
                                <span>Uploaded</span>
                              </span>
                              <span className="ddm-doc-action" style={{ cursor: "pointer", color: "#2563eb", textDecoration: "underline", fontSize: 11 }} onClick={() => customAlert({ title: 'Download Document', message: `Downloading document: ${doc.name}`, type: 'success' })}>
                                Download
                              </span>
                            </>
                          ) : (
                            <span className="ddm-doc-badge" style={{ backgroundColor: "#fee2e2", color: "#dc2626", padding: "4px 8px", borderRadius: 4, fontSize: 11, fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 4 }}>
                              <IconCrossCircle size={10} style={{ color: "#dc2626" }} />
                              <span>Missing</span>
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="ddm-footer">
                <button className="ad-btn-secondary" onClick={() => setSelectedDealDetails(null)}>
                  Close Audit View
                </button>
              </div>
            </div>
          </>
        );
      })()}

    </div>
  );
}

export default AdminDashboardPage;
